import { getAuth } from 'firebase/auth';

/**
 * Obtém os custom claims do usuário autenticado
 * @returns {Promise<Object>} Claims do usuário
 */
export const getUserCustomClaims = async () => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('Usuário não autenticado');
    }

    const tokenResult = await currentUser.getIdTokenResult(true);
    return tokenResult.claims || {};
  } catch (error) {
    console.error('Erro ao obter claims:', error);
    return {};
  }
};

/**
 * Verifica se o usuário atual é administrador
 * @returns {Promise<boolean>} True se for admin
 */
export const isUserAdmin = async () => {
  try {
    const claims = await getUserCustomClaims();
    return claims.admin === true;
  } catch (error) {
    console.error('Erro ao verificar se é admin:', error);
    return false;
  }
};
